/* Perf Defer v1.0.2 — SportMeals 3.0
   Verplaats niet-kritische taken na first paint
   - Defer third-party scripts (Trustpilot/Klaviyo/…)
   - Optioneel CSS uitstellen met link[data-defer-style="true"]
   - Lazy/decoding op non-hero images
   - LCP boost: fetchpriority=high + eager op eerste grote zichtbare image
*/
(function () {
  'use strict';

  // === Config uit data-attribuut op het <script> element ===
  // data-relax is een JSON-boolean ("true"/"false")
  var SCRIPT = document.currentScript || document.querySelector('script[data-perf-defer]');
  var RELAX_THIRD_PARTY = true;
  try {
    if (SCRIPT && SCRIPT.hasAttribute('data-relax')) {
      var val = SCRIPT.getAttribute('data-relax');
      RELAX_THIRD_PARTY = JSON.parse(val);
    }
  } catch (e) {
    RELAX_THIRD_PARTY = SCRIPT && SCRIPT.getAttribute('data-relax') === 'true';
  }

  // === Patterns voor third-party widgets ===
  var THIRD_PARTY_PATTERNS = [
    /trustpilot\.com/i,
    /static\.klaviyo\.com/i,
    /klaviyo\.com/i,
    /yotpo\.com/i,
    /judge\.me/i,
    /hotjar\.com/i,
    /google-analytics\.com/i
  ];

  function isThirdParty(src) {
    return THIRD_PARTY_PATTERNS.some(function (rx) { return rx.test(src || ''); });
  }

  // 1) Defer third-party <script> waar mogelijk (zonder kritieke storefront code te breken)
  function deferThirdPartyScripts() {
    if (!RELAX_THIRD_PARTY) return;

    var scripts = document.querySelectorAll('script[src]');
    for (var i = 0; i < scripts.length; i++) {
      var s = scripts[i];
      var src = s.getAttribute('src') || '';
      if (!src) continue;

      // Respecteer expliciete keep
      if (s.hasAttribute('data-perf-keep')) continue;

      if (isThirdParty(src)) {
        if (!s.hasAttribute('async') && !s.hasAttribute('defer')) {
          s.setAttribute('defer', 'defer');
        }
      }
    }
  }

  // 2) Styles na idle inladen, alleen als expliciet gemarkeerd
  function deferStyles() {
    var links = document.querySelectorAll('link[rel="stylesheet"][data-defer-style="true"]');
    for (var i = 0; i < links.length; i++) {
      var l = links[i];
      var href = l.getAttribute('href');
      if (!href) continue;

      // Preload + pas later activeren
      var preload = document.createElement('link');
      preload.rel = 'preload';
      preload.as = 'style';
      preload.href = href;

      // Deactiveer tijdelijk en injecteer preload
      l.disabled = true;
      document.head.appendChild(preload);

      // Veiligheidsmarge om render-blocking te vermijden
      (function (linkEl) {
        setTimeout(function () { linkEl.disabled = false; }, 1200);
      })(l);
    }
  }

  // 3) Afbeeldingen tunen zonder LCP/hero te raken
  function tuneImages() {
    var nodeList = document.querySelectorAll('img');
    if (!nodeList || !nodeList.length) return;

    var imgs = Array.prototype.slice.call(nodeList);
    var hero = null;

    // Heuristiek: eerste zichtbare grotere image als 'hero'
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      // skip als hidden via CSS (display:none)
      if (im.clientWidth === 0 || im.clientHeight === 0) continue;

      var rect = im.getBoundingClientRect();
      if (rect.top < (window.innerHeight || 800) && rect.width > 400 && rect.height > 250) {
        hero = im; break;
      }
    }

    // Non-hero: decoding async + lazy
    for (var j = 0; j < imgs.length; j++) {
      var pic = imgs[j];
      if (pic === hero) continue;
      if (!pic.hasAttribute('decoding')) pic.setAttribute('decoding', 'async');
      if (!pic.hasAttribute('loading')) pic.setAttribute('loading', 'lazy');
    }

    // Hero: eager + fetchpriority high + dimensies (indien bekend)
    if (hero) {
      hero.setAttribute('loading', 'eager');
      hero.setAttribute('fetchpriority', 'high');

      if (!hero.hasAttribute('width') && hero.naturalWidth) hero.setAttribute('width', hero.naturalWidth);
      if (!hero.hasAttribute('height') && hero.naturalHeight) hero.setAttribute('height', hero.naturalHeight);
    }
  }

  function run() {
    try {
      deferThirdPartyScripts();
      deferStyles();
      tuneImages();
    } catch (e) {
      // fail-safe: nooit breken
      if (window.console && console.warn) console.warn('[perf-defer] skipped', e);
    }
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 1500 });
  } else {
    setTimeout(run, 600);
  }
})();
